import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Input, TextArea, Checkbox, Button} from 'semantic-ui-react';
import {setErrorMessage, clearErrorMessage} from '../../../../../common/components/form/common';
import {Actions} from '../../../../../common/actions';
import './form.scss';

class Form extends Component {
  onChangeValueField({fieldType, fieldId, optionId, value, isOther, isMultipleSelection}) {
    this.props.setValueInForm({fieldType, fieldId, optionId, value, isOther, isMultipleSelection});
  }

  onChangeTextField({fieldType, fieldId, optionId, isOther}, event) {
    const value = event.target.value;
    this.onChangeValueField({fieldType, fieldId, optionId, value, isOther});
  }

  onCheckboxChange({fieldType, fieldId, optionId, isOther, isMultipleSelection}, event, value) {
    const isChecked = value;
    this.onChangeValueField({fieldType, fieldId, optionId, 'value': isChecked, isOther, isMultipleSelection});
  }

  downloadButtonClick(config) {
    const pdfs = Buffer.from(config.file, 'base64').toString('utf-8');
    const len = pdfs.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = pdfs.charCodeAt(i);
    }
    this.saveDowloadedData(bytes.buffer, config.name);
  }
  
  saveDowloadedData(data, filename) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const blob = new Blob([data], {'type': 'octet/stream'});
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  renderTextArea(field) {
    const {answers, isDisplayMode} = this.props;
    const fieldType = field.type;
    const fieldId = field.id;
    const isRequired = field.isRequired && !answers[fieldId];
    return (
      <Grid.Column width={16}>
        <TextArea
          rows={5}
          value={answers[fieldId]}
          onChange={(event) => this.onChangeTextField({fieldType, fieldId}, event)}
          onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
          onInput={clearErrorMessage}
          disabled={isDisplayMode}
          autoComplete='off'
          className={isRequired ? 'required' : ''}
        />
      </Grid.Column>
    );
  }

  renderImagePreview(config) {
    const mimetype = config.image && config.image.mimetype ? config.image.mimetype : '';

    if (mimetype && mimetype.includes('image')) {
      const file = config.image.file;
      return <img className='image' alt='preview' src={`data:image/jpeg;base64, ${file}`} />;
    }
    return config.name;
  }

  renderFileField(field) {
    const config = field.config || {};

    return (
      <Grid.Column width={16} className='file-template-container'>
        <div className='file-name'>{this.renderImagePreview(config)}</div>
        <Button
          primary
          type='submit'
          className='toyota-primary'
          onClick={() => this.downloadButtonClick(config)}
        >
             Descargar
        </Button>
      </Grid.Column>
    );
  }

  renderTextFields(options, {fieldType, fieldId}) {
    const {answers, isDisplayMode} = this.props;

    return options.map((option, optionPosition) => {
      const optionId = option.id;
      const maxLength = option.config && option.config.maxLength ? option.config.maxLength : 50;
      const existPreffix = option.config && option.config.preffix ? option.config.preffix : '';
      const existSuffix = option.config && option.config.suffix ? option.config.suffix : '';

      return (
        <Grid.Column key={optionPosition} width={4}>
          <div>
            {option.label}
          </div>
          <div className='fields-container'>
            {existPreffix}
            <Input
              value={answers[optionId]}
              required={option.isRequired}
              type={option.type}
              maxLength={maxLength}
              onChange={(event) => this.onChangeTextField({fieldType, fieldId, optionId, 'isOther': false}, event)}
              onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
              onInput={clearErrorMessage}
              placeholder={option.label}
              disabled={isDisplayMode}
              autoComplete='off'
            />
            {existSuffix}
          </div>
        </Grid.Column>
      );
    });
  }

  renderMultipleSelection(options, {fieldType, fieldId}) {
    const {answers, isDisplayMode} = this.props;

    return options.map((option, optionPosition) => {
      const optionId = option.id;
      const isChecked = answers[fieldId] && answers[fieldId][optionId] ? answers[fieldId][optionId] : false;
      return (
        <Grid.Column key={optionPosition} width={4} className='fields-container' >
          <Checkbox
            label={option.label}
            checked={isChecked}
            onChange={(event, {checked}) => {
              this.onCheckboxChange(
                {fieldType, fieldId, optionId, 'isMultipleSelection': true, 'isOther': option.isOther},
                event, checked);
            }}
            disabled={isDisplayMode}
          />
          {this.renderOtherField(option, {fieldId, optionId})}
        </Grid.Column>
      );
    });
  }

  renderOtherField(option, {fieldId, optionId}) {
    if (!option.isOther) {
      return null;
    }
    const {answers, isDisplayMode} = this.props;
    const fieldType = option.otherConfig && option.otherConfig.type ? option.otherConfig.type : 'text';
    const maxLength = option.otherConfig && option.otherConfig.maxLength ? option.otherConfig.maxLength : 50;
    const existPreffix = option.otherConfig && option.otherConfig.preffix ? option.otherConfig.preffix : '';
    const existSuffix = option.otherConfig && option.otherConfig.suffix ? option.otherConfig.suffix : '';

    const isChecked = answers[fieldId] && answers[fieldId][optionId] ? answers[fieldId][optionId] : false;
    const value = answers[fieldId] && answers[fieldId][`${optionId}-other`] ?
      answers[fieldId][`${optionId}-other`] : '';

    return (
      <div className='fields-container'>
        {existPreffix}
        <Input
          value={value}
          required={true}
          disabled={!isChecked || isDisplayMode}
          type={option.otherConfig.type}
          maxLength={maxLength}
          onChange={(event) => this.onChangeTextField({fieldType, fieldId, optionId, 'isOther': true}, event)}
          onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
          onInput={clearErrorMessage}
          autoComplete='off'
        />
        {existSuffix}
      </div>
    );
  }

  renderSingleSelection(options, {fieldType, fieldId}) {
    const {answers, isDisplayMode} = this.props;

    return options.map((option, optionPosition) => {
      const optionId = option.id;
      const isChecked = answers[fieldId] && answers[fieldId][optionId] ? answers[fieldId][optionId] : false;
      return (
        <Grid.Column key={optionPosition} width={4}>
          <Checkbox
            radio
            label={option.label}
            name={`field-${fieldId}`}
            checked={isChecked}
            onChange={(event, {checked}) => {
              this.onCheckboxChange({fieldType, fieldId, optionId, 'isMultipleSelection': false}, event, checked);
            }}
            disabled={isDisplayMode}
          />
        </Grid.Column>
      );
    });
  }

  renderFieldForm(field) {
    const fieldType = field.type;
    const fieldId = field.id;

    if (fieldType === 'text' || fieldType === 'number') {
      return this.renderTextFields(field.options, {fieldType, fieldId});
    }
    if (fieldType === 'textArea') {
      return this.renderTextArea(field);
    }
    if (fieldType === 'checkbox') {
      const isMultipleSelection = field.config ? field.config.multiple : true;
      if (isMultipleSelection) {
        return this.renderMultipleSelection(field.options, {fieldType, fieldId});
      }
      return this.renderSingleSelection(field.options, {fieldType, fieldId});
    }
    if (fieldType === 'file') {
      return this.renderFileField(field);
    }
  }

  renderSubTitle(title) {
    if (!title) {
      return null;
    }
    return (
      <div className='title-bar'>
        <div className='title'>
          <h4>{title}</h4>
        </div>
      </div>
    );
  }

  renderSectionsFields(fields) {
    return fields.map((field, fieldPosition) => {
      return (
        <div key={fieldPosition}>
          {this.renderSubTitle(field.label)}
          <Grid textAlign='left'>
            <Grid.Row>
              {this.renderFieldForm(field)}
            </Grid.Row>
          </Grid>
        </div>
      );
    });
  }

  renderSections() {
    const {sections} = this.props;

    return sections.map((section, sectionPosition) => {
      return (
        <Card fluid raised key={sectionPosition} className='section-container'>
          <div className='title-bar'>
            <div className='title'>
              <h3>{section.title}</h3>
            </div>
          </div>

          {this.renderSectionsFields(section.fields)}
        </Card>
      );
    });
  }

  render() {
    return (
      <div className='form-template-tab'>
        {this.renderSections()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'sections': state.templateFTR.sections,
    'answers': state.templateFTR.answers,
  };
};

const {
  setValueInForm,
} = Actions;

export default connect(mapStateToProps, {
  setValueInForm,
})(Form);
